import { PollResultItem } from "../../../models/poll.model";

export interface RankedPollResultItem extends PollResultItem {
    rank: number;
    rankLabel: string;
}

// Rank has 1-based start index; ties are labeled "T-{rank}", singletons just "{rank}".
// O(n) time/space: each element is scanned once to find its tie-group's end, then copied
// once into `ranked` — no element is revisited across outer iterations.
export function rankPollResults(orderedResults: PollResultItem[]): RankedPollResultItem[] {
    const ranked: RankedPollResultItem[] = [];
    let index = 0;
    while (index < orderedResults.length) {
        const count = orderedResults[index].count;
        let end = index;
        while (end < orderedResults.length && orderedResults[end].count === count) end++;

        const rank = index + 1;
        const rankLabel = end - index > 1 ? `T-${rank}` : `${rank}`;
        for (let i = index; i < end; i++) {
            ranked.push({ ...orderedResults[i], rank, rankLabel });
        }
        index = end;
    }
    return ranked;
}
